import { api } from ".";
import type { Policy, PolicyFormData } from "@/lib/queries/policies";

function addUserToPolicy(policyId: number, userId: string) {
  return api.auth.raw
    .post(`api/v1/policies/${policyId}/users`, {
      json: { policy_id: policyId, user_id: userId },
    })
    .json();
}

function removeUserFromPolicy(policyId: number, userId: string) {
  return api.auth.raw.delete(`api/v1/policies/${policyId}/users/${userId}`);
}

function addUsersToPolicyBulk(policyId: number, userIds: Array<string>) {
  return api.auth.raw
    .post(`api/v1/policies/${policyId}/users/bulk`, {
      json: { user_ids: userIds },
    })
    .json();
}

function addGroupToPolicy(policyId: number, groupId: number) {
  return api.auth.raw
    .post(`api/v1/policies/${policyId}/groups`, {
      json: { policy_id: policyId, group_id: groupId },
    })
    .json();
}

function removeGroupFromPolicy(policyId: number, groupId: number) {
  return api.auth.raw.delete(`api/v1/policies/${policyId}/groups/${groupId}`);
}

function addGroupsToPolicyBulk(policyId: number, groupIds: Array<number>) {
  return api.auth.raw
    .post(`api/v1/policies/${policyId}/groups/bulk`, {
      json: { group_ids: groupIds },
    })
    .json();
}

function addEntityToPolicy(policyId: number, entityId: number) {
  return api.auth.raw
    .post(`api/v1/policies/${policyId}/entities`, {
      json: { entity_id: entityId },
    })
    .json();
}

function removeEntityFromPolicy(policyId: number, entityId: number) {
  return api.auth.raw.delete(`api/v1/policies/${policyId}/entities/${entityId}`);
}

function addEntitiesToPolicyBulk(policyId: number, entityIds: Array<number>) {
  return api.auth.raw
    .post(`api/v1/policies/${policyId}/entities/bulk`, {
      json: { entity_ids: entityIds },
    })
    .json();
}

function createPolicy(data: PolicyFormData) {
  return api.auth.raw.post("api/v1/policies/", { json: data }).json<Policy>();
}
function updatePolicy(id: number, data: PolicyFormData) {
  return api.auth.raw.patch(`api/v1/policies/${id}`, { json: data }).json<Policy>();
}
function deletePolicy(id: number) {
  return api.auth.raw.delete(`api/v1/policies/${id}`);
}

export default {
  addUserToPolicy,
  removeUserFromPolicy,
  addUsersToPolicyBulk,
  addGroupToPolicy,
  removeGroupFromPolicy,
  addGroupsToPolicyBulk,
  addEntityToPolicy,
  removeEntityFromPolicy,
  addEntitiesToPolicyBulk,
  createPolicy,
  updatePolicy,
  deletePolicy,
};
